module.exports = __webpack_public_path__ + "img/fi-rr-presentation.f8a713f7.svg";